"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenVerifierService = void 0;
var error_service_1 = require("./error-service");
var idtoken_verifier_1 = require("idtoken-verifier");
var TokenVerifierService = /** @class */ (function () {
    function TokenVerifierService(config, platform) {
        var audience = platform === 'a' ? config.androidClientId : platform === 'i' ? config.iosClientId : null;
        this.verifier = new idtoken_verifier_1.default({
            issuer: config.issuer,
            audience: audience,
            leeway: config.leeway || 60,
            maxAge: config.max_age,
        });
    }
    TokenVerifierService.prototype.validateToken = function (token, cb) {
        this.verifier.verify(token, function (err, payload) {
            if (err) {
                return cb((0, error_service_1.invalidTokenError)(err.message));
            }
            cb(null, payload);
        });
    };
    TokenVerifierService.prototype.validateAccessToken = function (accessToken, atHash, cb) {
        return this.verifier.validateAccessToken(accessToken, 'RS256', atHash, cb);
    };
    TokenVerifierService.prototype.decode = function (idToken) {
        return this.verifier.decode(idToken);
    };
    return TokenVerifierService;
}());
exports.TokenVerifierService = TokenVerifierService;
